import { useAuth } from '@/contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { useAttestation18Plus } from '@/hooks/useAttestation';
import { AttestationGate } from '@/components/auth/AttestationGate';
import sabotagelogo from '@/assets/sabotage-logo.png';

const Splash = () => (
  <div className="min-h-screen bg-background flex flex-col items-center justify-center">
    <img src={sabotagelogo} alt="Sabotage Fantasy" className="h-14 w-auto animate-pulse" />
  </div>
);

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  // Certifier 18+ self-attestation. Every authed app route passes through here, so
  // it's the single choke point that covers email AND OAuth signups from every entry
  // point. The gate renders IN PLACE (URL unchanged) so the landing chain / returnTo
  // / invite-join destination resolves normally once it's satisfied.
  const { data: attested, isPending: attPending } = useAttestation18Plus(user?.id);

  if (isLoading) return <Splash />;

  if (!user) {
    return <Navigate to="/auth" replace state={{ from: location.pathname }} />;
  }

  // Still resolving attestation status — don't flash the app or the gate.
  if (attPending) return <Splash />;

  // Not attested (false) OR undetermined after a fetch error → show the gate.
  // Fail-safe: never wave an unconfirmed user into the app.
  if (attested !== true) return <AttestationGate />;

  return <>{children}</>;
};

export default ProtectedRoute;
